<div class="container" style="padding-bottom: 370px;">
  <h1 class="text-center">Pomoč</h1>
  <div *ngFor="let item of helpItems; let i = index" class="card m-2 p-3 shadow-sm" style="cursor: pointer;" (click)="toggleExpand(i)">
    <h4 id="title">{{ item.title }}</h4>
    <div [collapse]="!item.expanded" [isAnimated]="true">
      <div class="row">
        <div class="col-lg-2">
          <!-- Use [innerHTML] to render HTML content -->
          <p [innerHTML]="item.text"></p>
        </div>
        <div class="col-lg-10">
          <div *ngFor="let image of item.images" class="d-flex justify-content-center">
            <img [src]="image" alt="Item Image" class="img-fluid mb-2">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
